import styled from "styled-components"

export const ContainerStyled = styled.div`
    padding: 20px;
    margin: 0 auto;
    max-width: 1024px;
`